import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSalutation, deleteSalutation, getAllSalutation, updateSalutation } from '../../redux/rtk/features/masters/salutationSlice';
import PageTitle from '../page-header/PageHeader';

const SalutationMaster = () => {
  const { Title } = Typography;
  const [editingSalutation, setEditingSalutation] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.salutation);

  useEffect(() => {
    dispatch(getAllSalutation());
  }, [dispatch]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingSalutation) {
        // Update existing salutations
        const result = await dispatch(
          updateSalutation({ id: editingSalutation.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllSalutation());
        } else {
          message.error('Error updating salutations!');
        }
      } else {
        // Add new salutations
        const result = await dispatch(addSalutation(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllSalutation());
        } else {
          message.error('Error adding salutations!');
        }
      }
      setEditingSalutation(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update salutations!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteSalutation(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllSalutation()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Title',
      dataIndex: 'salutations',
      key: 'salutations',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingSalutation(record); form.setFieldsValue(record);}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this salutation?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingSalutation ? 'Edit Title' : 'Add Title'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="salutation-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
      
          <Form.Item
            name="salutations"
            label="Title"
            rules={[{ required: true, message: 'Please enter a Title!' }]}
          >
            <Input placeholder="Enter Title " />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingSalutation ? 'Update Title' : 'Add Title'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Title List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SalutationMaster;
